import { LayoutState } from '../../models';
import { StoreNative } from '../Store';
import { SET_EDIT_MODE, SET_MOBILE_MODE } from './layout.actions';

const defaultState: StoreNative<LayoutState> = {
    value: {
        isEditMode: false,
        isMobileMode: false
    },
    isLoaded: true,
    hasError: false,
    isLoading: false,
} as StoreNative<LayoutState>;

export function layoutReducer(state: StoreNative<LayoutState> = defaultState, action: { type: string; payload: any }) {
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case SET_MOBILE_MODE:
                if (state.value.isMobileMode !== action.payload.isMobileMode) {
                    newState = (Object as any).assign({}, defaultState);
                    newState.value = {
                        isEditMode: state.value.isEditMode,
                        isMobileMode: action.payload.isMobileMode
                    };
                }
                break;
            case SET_EDIT_MODE:
                if (state.value.isEditMode !== action.payload.isEditMode) {
                    newState = (Object as any).assign({}, defaultState);
                    newState.value = {
                        isEditMode: action.payload.isEditMode,
                        isMobileMode: state.value.isMobileMode
                    };
                }
                break;
        }
    }
    return newState;
}